<template>
  <div class="admin-menus">
    <div class="options">
      <div
        class="option"
        v-for="item in menusOption"
        :key="item.id"
        @click="openPage(item)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="lists gridStyleReport" :style="{ '--lengthList': lengthList }">
      <div
        class="option"
        :class="item.type"
        :style="{ color: item.hot ? 'red' : '#61b88e' }"
        v-for="item in listOption"
        :key="item.id"
        @click="openPage(item)"
      >
        <i class="el-icon-finished" v-if="item.type === 'list'" />{{
          item.title
        }}
      </div>
    </div>
    <div
      class="lists gridStyleList"
      :style="{ '--lengthReport': lengthReport }"
    >
      <div
        class="option"
        :class="item.type"
        :style="{
          color: item.hot ? 'red' : '#61b88e',
          borderBottom: item.hot ? '2px solid red' : '2px solid #61b88e',
        }"
        v-for="item in reportOption"
        :key="item.id"
        @click="openPage(item)"
      >
        <i class="el-icon-finished" v-if="item.type === 'list'" />{{
          item.title
        }}
      </div>
    </div>
    <p class="no-data" v-if="!menus.length">暂无菜单</p>
  </div>
  <div class="admin-menu">
    <div class="options">
      <div
        class="option"
        style="border: 1px solid red"
        v-for="item in menusOptions"
        :key="item.id"
        @click="openPage(item)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="lists gridStyleReport" :style="{ '--lengthList': lengthList }">
      <div
        class="option"
        :class="item.type"
        style="border: 1px solid red"
        :style="{ color: item.hot ? 'red' : '#61b88e' }"
        v-for="item in listOptions"
        :key="item.id"
        @click="openPage(item)"
      >
        <i class="el-icon-finished" v-if="item.type === 'list'" />{{
          item.title
        }}
      </div>
    </div>
    <div
      class="lists gridStyleList"
      :style="{ '--lengthReport': lengthReport }"
    >
      <div
        class="option"
        :class="item.type"
        :style="{
          color: item.hot ? 'red' : '#61b88e',
          borderBottom: item.hot ? '2px solid red' : '2px solid #61b88e',
        }"
        v-for="item in reportOptions"
        style="border: 1px solid red"
        :key="item.id"
        @click="openPage(item)"
      >
        <i class="el-icon-finished" v-if="item.type === 'list'" />{{
          item.title
        }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lengthList: 0,
      lengthReport: 0,
    };
  },
  computed: {
    menusOption() {
      return this.menus.filter((i) => !i.type && !i.show);
    },
    menusOptions() {
      return this.menus.filter((i) => !i.type && i.show);
    },
    listOption() {
      return this.menus.filter((i) => i.type === "list" && !i.show);
    },
    listOptions() {
      return this.menus.filter((i) => i.type === "list" && i.show);
    },
    reportOption() {
      const opReport = this.menus.filter((i) => i.type === "report" && !i.show);
      return opReport;
    },
    reportOptions() {
      const opReport = this.menus.filter((i) => i.type === "report" && i.show);
      return opReport;
    },
  },
  watch: {
    listOption: {
      handler(newList) {
        this.lengthList = newList.length < 10 ? newList.length : 10;
      },
      immediate: true,
    },
    reportOption: {
      handler(newList) {
        this.lengthReport = newList.length < 10 ? newList.length : 10;
      },
      immediate: true,
    },
    menus: {
      handler() {
        this.lengthList =
          this.listOption.length < 10 ? this.listOption.length : 10;
        this.lengthReport =
          this.reportOption.length < 10 ? this.reportOption.length : 10;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    openPage(item) {
      this.$emit("open", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./AdminMenus";
.gridStyleReport {
  grid-template-rows: repeat(var(--lengthList, 10), 1fr);
  width: 220px;
}
.gridStyleList {
  grid-template-rows: repeat(var(--lengthReport, 10), 1fr);
}
.list {
  color: black !important;
}
//上半区
.admin-menus {
  width: 100%;
  height: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  position: relative;
  padding-top: 24px;
  .divide {
    width: 100%;
    height: 20px;
  }
  .no-data {
    position: absolute;
    left: 50%;
    top: 50%;
    color: black;
    font-size: 20px;
    letter-spacing: 3px;
    transform: translate(-50%, -50%);
    user-select: none;
  }
  .options {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    justify-items: center;
    align-items: center;
  }
  .lists {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    grid-auto-flow: column;
    justify-items: center;
    align-items: center;
    padding: 20px 0 20px 40px;
  }
  .option {
    display: inline-block;
    vertical-align: top;
    width: 170px;
    padding: 10px 6px;
    margin: 5px;
    box-sizing: border-box;
    color: black;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    border-radius: 40px;
    user-select: none;
    font-size: 14px;
    &:not(.report):not(.list):hover {
      background-color: black;
      color: red;
    }
    &.report {
      border: 0;
      border-bottom: 2px solid $font-color;
      border-radius: 0;
    }
    &.list {
      border: 0;
      border-radius: 0;
      i {
        margin-right: 6px;
      }
    }
  }
}
//下半区
.admin-menu {
  width: 100%;
  height: 50%;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  position: relative;
  .divide {
    width: 100%;
    height: 20px;
  }
  .no-data {
    position: absolute;
    left: 50%;
    top: 50%;
    color: black;
    font-size: 20px;
    letter-spacing: 3px;
    transform: translate(-50%, -50%);
    user-select: none;
  }
  .options {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    justify-items: center;
    align-items: center;
  }
  .lists {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    grid-auto-flow: column;
    justify-items: center;
    align-items: center;
    padding: 20px 0 20px 40px;
  }
  .option {
    display: inline-block;
    vertical-align: top;
    width: 170px;
    padding: 10px 6px;
    margin: 5px;
    box-sizing: border-box;
    color: black;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    border-radius: 40px;
    user-select: none;
    font-size: 14px;
    &:not(.report):not(.list):hover {
      background-color: black;
      color: red;
    }
    &.report {
      border: 0;
      border-bottom: 2px solid $font-color;
      border-radius: 0;
    }
    &.list {
      border: 0;
      border-radius: 0;
      i {
        margin-right: 6px;
      }
    }
  }
}
//自适应上半区
@media screen and (max-width: 1100px) {
  .admin-menus {
    .options {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
}
@media screen and (max-width: 992px) {
  .admin-menus {
    .options {
      grid-template-columns: 1fr 1fr;
    }
  }
}
@media screen and (max-width: 720px) {
  .admin-menus {
    .options {
      grid-template-columns: 1fr;
    }
  }
}
@media screen and (max-width: 520px) {
  .admin-menus {
    .options {
      grid-template-columns: 1fr;
    }
  }
}
//自适应下半区
@media screen and (max-width: 1100px) {
  .admin-menu {
    .options {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
}
@media screen and (max-width: 992px) {
  .admin-menu {
    .options {
      grid-template-columns: 1fr 1fr;
    }
  }
}
@media screen and (max-width: 720px) {
  .admin-menu {
    .options {
      grid-template-columns: 1fr;
    }
  }
}
@media screen and (max-width: 520px) {
  .admin-menu {
    .options {
      grid-template-columns: 1fr;
    }
  }
}
</style>

